import { Injectable } from '@angular/core';
import { Menu, SubMenu } from './menu-models';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  menus: any = {};


  constructor(private permissionService: PermissionService) { }

  getMenu(user: any): { [key: string]: Menu } {
    this.permissionService.setUser(user);
    this.menus = {};
    this.addMenus();
    Object.keys(this.menus).forEach(key => {
      if (this.menus[key].subMenus && this.menus[key].subMenus.length) {
        this.menus[key].subMenus.sort((a: any, b: any) => a.position - b.position)
      }
    });
    return this.menus;
  }

  private addMenu(menu: Menu): void {
    if (menu.hasAnyPermission) {
      if (this.permissionService.hasAnyPermission(menu.permissions)) {
        this.menus[menu.key] = menu;
      }
    } else {
      if (this.permissionService.hasPermission(menu.permissions || [])) {
        this.menus[menu.key] = menu;
      }
    }
  }

  private addSubMenu(key: string, subMenu: SubMenu): void {
    if (this.menus[key] && this.permissionService.hasPermission(subMenu.permissions || [])) {
      if (!this.menus[key].subMenus) {
        this.menus[key].subMenus = [];
      }
      this.menus[key].subMenus!.push(subMenu);
    }
  }

  addMenus() {

    this.addMenu({
      title: "Signups",
      url: "signups",
      icon: this.getIcon("signups"),
      key: "signups",
      position: 1,
      permissions: [UserPermission.GET_SIGNUP]


    });

    this.addMenu({
      title: "Onboarding",
      url: "credentials",
      icon: this.getIcon("credentials"),
      key: "credentials",
      position: 2,
      permissions: [UserPermission.GET_ONBOARDING]
    });

    this.addMenu({
      title: "Dashboard",
      url: "dashboard",
      icon: this.getIcon("dashboard"),
      key: "dashboard",
      position: 2.2,
      permissions: [UserPermission.GET_TRIP, UserPermission.GET_DRIVRER_ACTIVITY]
    });

    this.addMenu({
      title: "Config",
      url: "configurations",
      icon: this.getIcon("configurations"),
      key: "configurations",
      position: 4,
      permissions: [
        UserPermission.GET_LOS,
        UserPermission.GET_SPACE_TYPE,
        UserPermission.GET_APPOINTMENT_TYPE,
        UserPermission.GET_ADDON,
        UserPermission.GET_SERVICE_AREAS,
        UserPermission.GET_CHANGE_REASON,
        UserPermission.GET_PLACE_TYPES,
        UserPermission.GET_CONFIGURATION
      ],
      hasAnyPermission: true
    });
    this.addMenu({
      title: "Members",
      url: "members",
      icon: this.getIcon("members"),
      key: "members",
      position: 5,
      permissions: [UserPermission.GET_MEMBER]
    });
    this.addSubMenu('members', {
      title: "Members",
      url: "members",
      position: 1,
      permissions: [UserPermission.GET_MEMBER]
    });
    this.addSubMenu('members', {
      title: "Import",
      url: "members/parse",
      position: 1,
      permissions: [UserPermission.MANAGE_MEMBER]
    });
    this.addMenu({
      title: "FS",
      url: "funding-sources",
      icon: this.getIcon("funding-sources"),
      key: "funding-sources",
      position: 6,
      permissions: [UserPermission.GET_FUNDING_SOURCE]
    });

    this.addMenu({
      title: "Statistics",
      url: "statistics",
      icon: this.getIcon("report"),
      key: "statistics",
      position: 8,
      permissions: [UserPermission.GET_TRIP]
    });

    this.addSubMenu('statistics', {
      title: "Statistics",
      url: "statistics",
      position: 1,
      permissions: [UserPermission.GET_TRIP]
    });

    this.addSubMenu('statistics', {
      title: "Reports",
      url: "statistics/reports",
      position: 2,
      permissions: [UserPermission.GET_TRIP]
    });

    // this.addSubMenu('statistics', {
    //   title: "Overview",
    //   url: "statistics/overview",
    //   position: 3,
    //   permissions: [UserPermission.GET_TRIP]
    // });

    //  this.addMenu({
    //   title: "Report",
    //   url: "partnerpay",
    //   icon: this.getIcon("partnerpay"),
    //   key: "partnerpay",
    //   position: 9,
    // });

    //  this.addSubMenu('partnerpay', {
    //   title: "Partner Pay Report",
    //   url: "partnerpay",
    //   position: 1,
    // });

    this.addMenu({
      title: "Quickbooks",
      url: "quickbook/customers",
      icon: this.getIcon("partnerpay"),
      key: "quickbook",
      position: 11,
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    });



    this.addSubMenu('quickbook', {
      title: "Customers",
      url: "quickbook/customers",
      position: 1,
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    });

    this.addSubMenu('quickbook', {
      title: "Invoices",
      url: "quickbook/invoices",
      position: 2,
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    });

    this.addSubMenu('quickbook', {
      title: "Payments",
      url: "quickbook/payments",
      position: 3,
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    });

    this.addSubMenu('quickbook', {
      title: "Vendors",
      url: "quickbook/vendors",
      position: 4,
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    });

    this.addSubMenu('quickbook', {
      title: "Bills",
      url: "quickbook/bills",
      position: 5,
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    });

    this.addSubMenu('quickbook', {
      title: "Bill Payments",
      url: "quickbook/bill-payments",
      position: 6,
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    });

    this.addSubMenu('quickbook', {
      title: "Services",
      url: "quickbook/services",
      position: 7,
      permissions: [UserPermission.MANAGE_QUICKBOOKS]
    });

    // Academy
    this.addMenu({
      title: "Academy",
      url: "academy",
      icon: this.getIcon("academy"),
      key: "academy",
      position: 12,
      // permissions: [UserPermission.academy]
    });

    this.addSubMenu('academy', {
      title: "Academy",
      url: "academy",
      position: 1,
    });


    this.addMenu({
      title: "Users",
      url: "users",
      icon: this.getIcon("users"),
      key: "users",
      position: 7,
      permissions: [UserPermission.GET_USERS]
    });

    this.addMenu({
      title: "Roles",
      url: "roles",
      icon: this.getIcon("roles"),
      key: "roles",
      position: 10,
      permissions: [UserPermission.GET_ROLE]
    });

    this.addSubMenu('roles', {
      title: "Roles",
      url: "roles",
      position: 1,
      permissions: [UserPermission.GET_ROLE, UserPermission.MANAGE_ROLE]
    });

    if (!environment.production) {
      this.addSubMenu('roles', {
        title: "Permissions",
        url: "roles/permissions",
        position: 2,
        permissions: [UserPermission.GET_ROLE, UserPermission.MANAGE_ROLE]
      });
    }

    this.addMenu({
      title: "Support",
      url: "support",
      icon: this.getIcon("tickets"),
      key: "support",
      position: 13,
      permissions: []
    });
    this.addSubMenu('support', {
      title: "Tickets",
      url: "support/tickets",
      position: 1,
      permissions: []
    });
    this.addSubMenu('support', {
      title: "Chats",
      url: "support/chats",
      position: 2,
      permissions: []
    });

    //   this.addMenu({
    //   title: "Mapview",
    //   url: "mapview",
    //   icon: this.getIcon("mapview"),
    //   key: "mapview",
    //   position: 12,
    //   permissions: [UserPermission.GET_ROLE, UserPermission.MANAGE_ROLE]
    // });

    this.addMenu({
      title: "Trips",
      url: "trips",
      icon: this.getIcon("trips"),
      key: "trips",
      position: 4,
      permissions: [UserPermission.GET_TRIP]
    });

    this.addSubMenu('trips', {
      title: "Trips",
      url: "trips",
      position: 1,
      permissions: [UserPermission.GET_TRIP]
    });
    this.addSubMenu('trips', {
      title: "Staging",
      url: "trips/staging",
      position: 2,
      permissions: [UserPermission.GET_TRIP]
    });
    this.addSubMenu('trips', {
      title: "Import",
      url: "trips/parsetrips",
      position: 3,
      permissions: [UserPermission.MANAGE_TRIP]
    });
    this.addSubMenu('trips', {
      title: "Event",
      url: "trips/event",
      position: 4,
      permissions: [UserPermission.GET_EVENT]
    });

    this.addSubMenu('trips', {
      title: "GPS",
      url: "trips/gps",
      position: 5,
      permissions: [UserPermission.GET_GPS]
    });
    this.addSubMenu('trips', {
      title: "Standingorder",
      url: "trips/standing-order",
      position: 6,
      permissions: [UserPermission.GET_STANDING_ORDER]
    });

    this.addSubMenu('trips', {
      title: "Monitoring",
      url: "trips/monitoring",
      position: 7,
      permissions: [UserPermission.GET_TRIP]
    });

    this.addSubMenu('trips', {
      title: "Create",
      url: "trips/new",
      position: 8,
      permissions: [UserPermission.MANAGE_TRIP]
    });

    this.addSubMenu('configurations', {
      title: "Level Of Service",
      url: "configurations/los",
      position: 1,
      permissions: [UserPermission.GET_LOS]
    });

    this.addSubMenu('configurations', {
      title: "Space Types",
      url: "configurations/spacetypes",
      position: 2,
      permissions: [UserPermission.GET_SPACE_TYPE]
    });

    this.addSubMenu('configurations', {
      title: "Appointment Type",
      url: "configurations/appointmenttype",
      position: 3,
      permissions: [UserPermission.GET_APPOINTMENT_TYPE]
    });

    this.addSubMenu('configurations', {
      title: "Addons",
      url: "configurations/addons",
      position: 4,
      permissions: [UserPermission.GET_ADDON]
    });
    this.addSubMenu('configurations', {
      title: "Service Areas",
      url: "configurations/service-areas",
      position: 5,
      permissions: [UserPermission.GET_SERVICE_AREAS]
    });
    this.addSubMenu('configurations', {
      title: "Change Reasons",
      url: "configurations/change-reasons",
      position: 7,
      permissions: [UserPermission.GET_CHANGE_REASON]
    });
    this.addSubMenu('configurations', {
      title: "Place Types",
      url: "configurations/place-types",
      position: 8,
      permissions: [UserPermission.GET_PLACE_TYPES]
    });

    this.addSubMenu('configurations', {
      title: "Config",
      url: "configurations/global",
      position: 8,
      permissions: [UserPermission.GET_CONFIGURATION]
    });

    this.addMenu({
      title: "Billing",
      url: "billing/vendor",
      icon: this.getIcon("billing"),
      key: "billing",
      position: 9,
      permissions: [UserPermission.GET_BILLINGS]
    });
    this.addSubMenu('billing', {
      title: "Fundingsource",
      url: "billing/fundingsource",
      position: 1,
      permissions: [UserPermission.GET_BILLINGS]
    });
    this.addSubMenu('billing', {
      title: "Vendor",
      url: "billing/vendor",
      position: 2,
      permissions: [UserPermission.GET_BILLINGS]
    });

    this.addSubMenu('billing', {
      title: "Primary Diagnosis",
      url: "billing/primary-diagnosis",
      position: 3,
      permissions: [UserPermission.GET_BILLINGS]
    });

    this.addSubMenu('billing', {
      title: "Modifier Codes",
      url: "billing/modifier-codes",
      position: 4,
      permissions: [UserPermission.GET_BILLINGS]
    });


    this.addMenu({
      title: "Payments",
      url: "payments/manuals",
      icon: this.getIcon("payments"),
      key: "payments",
      position: 10,
      permissions: [UserPermission.MANAGE_PAYMENT]
    });

    this.addSubMenu('payments', {
      title: "Manuals",
      url: "payments/manuals",
      position: 0,
      permissions: [UserPermission.MANAGE_PAYMENT]
    });

    this.addSubMenu('payments', {
      title: "Members",
      url: "payments",
      position: 1,
      permissions: [UserPermission.MANAGE_PAYMENT]
    });

    this.addSubMenu('payments', {
      title: "Transactions (Square)",
      url: "payments/transactions",
      position: 2,
      permissions: [UserPermission.MANAGE_PAYMENT]
    });
    this.addMenu({
      title: "Documents",
      url: "documents-statistics",
      icon: this.getIcon("documents"),
      key: "documents-statistics",
      position: 10,
      permissions: [UserPermission.GET_DOCUMENT_STATS]
    });


  }

  getIcon(menu: any) {
    switch (menu) {
      case 'dashboard':
        return `<svg xmlns="http://www.w3.org/2000/svg" class="size-6 dark:group-hover:text-white" viewBox="0 0 24 24"><!-- Icon from Material Symbols Light by Google - https://github.com/google/material-design-icons/blob/master/LICENSE --><path fill="currentColor" d="M5.616 20q-.691 0-1.153-.462T4 18.384V5.616q0-.691.463-1.153T5.616 4h12.769q.69 0 1.153.463T20 5.616v12.769q0 .69-.462 1.153T18.384 20zm0-1H11.5V5H5.616q-.231 0-.424.192T5 5.616v12.769q0 .23.192.423t.423.192m6.885 0h5.885q.23 0 .423-.192t.192-.424V12h-6.5zm0-8H19V5.616q0-.231-.192-.424T18.384 5H12.5z"/></svg>`
      case 'signups':
        return `<svg class="size-5 dark:group-hover:text-white" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32">
        <path fill="currentColor" d="M16 22a4 4 0 1 0-4-4a4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2a2 2 0 0 1 2-2zM14 6h4v2h-4z" />
        <path fill="currentColor"
          d="M24 2H8a2.002 2.002 0 0 0-2 2v24a2.002 2.002 0 0 0 2 2h16a2.003 2.003 0 0 0 2-2V4a2.002 2.002 0 0 0-2-2Zm-4 26h-8v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Zm2 0v-2a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3v2H8V4h16v24Z" />
      </svg>`
      case 'configurations':
        return `<svg class="size-5 dark:group-hover:text-white" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24">
        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" color="currentColor">
        <path d="M2.256 15.632c.034-.323.268-.583.736-1.104l1.031-1.153c.252-.32.431-.875.431-1.375s-.179-1.056-.43-1.375L2.991 9.472c-.468-.52-.702-.781-.736-1.104s.14-.627.49-1.234l.494-.857c.373-.648.56-.972.878-1.1c.317-.13.676-.028 1.395.176l1.22.343c.459.106.94.046 1.358-.169l.337-.194a2 2 0 0 0 .788-.968l.334-.997c.22-.66.33-.99.591-1.18C10.403 2 10.75 2 11.444 2h1.115c.694 0 1.042 0 1.303.189s.371.519.59 1.179l.335.997a2 2 0 0 0 .788.968l.337.194c.418.215.9.275 1.358.17l1.22-.344c.719-.204 1.078-.306 1.395-.177c.318.13.505.453.878 1.101l.493.857c.35.607.525.91.491 1.234s-.268.583-.736 1.104l-1.031 1.153c-.252.319-.431.875-.431 1.375s.179 1.056.43 1.375l1.032 1.153c.468.52.702.781.736 1.104s-.14.627-.49 1.234l-.494.857c-.373.648-.56.972-.878 1.1c-.317.13-.676.028-1.395-.176l-1.22-.343a2 2 0 0 0-1.359.169l-.336.194c-.36.23-.636.57-.788.968l-.334.997c-.22.66-.33.99-.591 1.18c-.261.188-.609.188-1.303.188h-1.115c-.694 0-1.041 0-1.303-.189c-.261-.189-.371-.518-.59-1.178"/><path d="M2.737 18.78c1.08-1.08 4.752-4.716 5.112-5.136c.381-.444.072-1.044.256-2.904c.089-.9.282-1.574.836-2.076c.66-.624 1.2-.624 3.06-.666c1.62.042 1.812-.138 1.98.282c.12.3-.24.48-.672.96c-.96.96-1.524 1.44-1.578 1.74c-.39 1.32 1.146 2.1 1.986 1.26c.318-.318 1.788-1.8 1.932-1.92c.108-.096.367-.092.492.06c.108.106.12.12.108.6c-.01.444-.006 1.082-.004 1.74c.001.852-.044 1.8-.404 2.28c-.72 1.08-1.92 1.14-3 1.188c-1.02.06-1.86-.048-2.124.144c-.216.108-1.356 1.308-2.736 2.688l-2.46 2.46c-2.04 1.62-4.284-.9-2.784-2.7"/>
        </g>
        </svg>`
      case 'members':
        return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 dark:group-hover:text-white">
        <path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
      </svg>`


      case 'companies':
        return `<svg xmlns="http://www.w3.org/2000/svg" class="size-5 dark:group-hover:text-white" viewBox="0 0 24 24"><path fill="currentColor" d="M2 2h14v4h6v16H2zm18 6h-4v2h2v2h-2v2h2v2h-2v2h2v2h2zm-6-4H4v16h2v-2h6v2h2zM6 6h2v2H6zm6 0h-2v2h2zm-6 4h2v2H6zm6 0h-2v2h2zm-6 4h2v2H6zm6 0h-2v2h2z"/></svg>`
      case 'credentials':
        return `<svg xmlns="http://www.w3.org/2000/svg" class="size-5 dark:group-hover:text-white" viewBox="0 0 14 14"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M9.5 1.5H11a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h1.5"/><rect width="5" height="2.5" x="4.5" y=".5" rx="1"/><path d="M4.5 5.5h5M4.5 8h5m-5 2.5h5"/></g></svg>`
      case 'users':
        return `<svg color="currentColor"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 dark:group-hover:text-white">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
                </svg>`
      case 'roles':
        return `
        <svg color="currentColor" xmlns="http://www.w3.org/2000/svg" class="fill-current size-5 dark:group-hover:text-white" viewBox="0 0 32 32"><path d="M19.307 3.21a2.91 2.91 0 1 0-.223 1.94a11.64 11.64 0 0 1 8.232 7.049l1.775-.698a13.58 13.58 0 0 0-9.784-8.291m-2.822 1.638a.97.97 0 1 1 0-1.939a.97.97 0 0 1 0 1.94m-4.267.805l-.717-1.774a13.58 13.58 0 0 0-8.291 9.784a2.91 2.91 0 1 0 1.94.223a11.64 11.64 0 0 1 7.068-8.233m-8.34 11.802a.97.97 0 1 1 0-1.94a.97.97 0 0 1 0 1.94m12.607 8.727a2.91 2.91 0 0 0-2.599 1.62a11.64 11.64 0 0 1-8.233-7.05l-1.774.717a13.58 13.58 0 0 0 9.813 8.291a2.91 2.91 0 1 0 2.793-3.578m0 3.879a.97.97 0 1 1 0-1.94a.97.97 0 0 1 0 1.94M32 16.485a2.91 2.91 0 1 0-4.199 2.599a11.64 11.64 0 0 1-7.05 8.232l.718 1.775a13.58 13.58 0 0 0 8.291-9.813A2.91 2.91 0 0 0 32 16.485m-2.91.97a.97.97 0 1 1 0-1.94a.97.97 0 0 1 0 1.94"/><path d="M19.19 16.35a3.879 3.879 0 1 0-5.42 0a4.85 4.85 0 0 0-2.134 4.014v1.939h9.697v-1.94a4.85 4.85 0 0 0-2.143-4.014m-4.645-2.774a1.94 1.94 0 1 1 3.88 0a1.94 1.94 0 0 1-3.88 0m-.97 6.788a2.91 2.91 0 1 1 5.819 0z" class="ouiIcon__fillSecondary"/></svg>
`
      case 'trips':
        return `<svg class="size-5 dark:group-hover:text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
  <path fill="currentColor" d="M14.844 20H6.5C5.121 20 4 18.879 4 17.5S5.121 15 6.5 15h7c1.93 0 3.5-1.57 3.5-3.5S15.43 8 13.5 8H8.639a9.812 9.812 0 0 1-1.354 2H13.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5h-7C4.019 13 2 15.019 2 17.5S4.019 22 6.5 22h9.593a10.415 10.415 0 0 1-1.249-2zM5 2C3.346 2 2 3.346 2 5c0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5 6.5z"></path>
  <path fill="currentColor" d="M19 14c-1.654 0-3 1.346-3 3c0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 19 18.5z"></path>
</svg>
`
      case 'report':
        return `<svg class="size-5 dark:group-hover:text-white" fill="none" stroke="currentColor" stroke-width="1.5"
                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
                            stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>`
      case 'funding-sources':
        return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 dark:group-hover:text-white">
  <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z" />
</svg>`
      case 'partnerpay':
        return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 dark:group-hover:text-white">
  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v7.5m2.25-6.466a9.016 9.016 0 0 0-3.461-.203c-.536.072-.974.478-1.021 1.017a4.559 4.559 0 0 0-.018.402c0 .464.336.844.775.994l2.95 1.012c.44.15.775.53.775.994 0 .136-.006.27-.018.402-.047.539-.485.945-1.021 1.017a9.077 9.077 0 0 1-3.461-.203M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
</svg>`
      case 'billing':
        return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 dark:group-hover:text-white">
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z" />
</svg>
`
      case 'tickets':
        return `<svg
        class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 h-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
        />
      </svg>`

      case 'mapview':
        return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z"></path>
      </svg>`
      case 'payments':
        return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z" />
</svg>`
      case 'academy':
        return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5" />
</svg>`
      case 'documents':
        return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
</svg>
`
      case 'tutorials':
        return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h1.5C5.496 19.5 6 18.996 6 18.375m-3.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-1.5A1.125 1.125 0 0 1 18 18.375M20.625 4.5H3.375m17.25 0c.621 0 1.125.504 1.125 1.125M20.625 4.5h-1.5C18.504 4.5 18 5.004 18 5.625m3.75 0v1.5c0 .621-.504 1.125-1.125 1.125M3.375 4.5c-.621 0-1.125.504-1.125 1.125M3.375 4.5h1.5C5.496 4.5 6 5.004 6 5.625m-3.75 0v1.5c0 .621.504 1.125 1.125 1.125m0 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m1.5-3.75C5.496 8.25 6 7.746 6 7.125v-1.5M4.875 8.25C5.496 8.25 6 8.754 6 9.375v1.5m0-5.25v5.25m0-5.25C6 5.004 6.504 4.5 7.125 4.5h9.75c.621 0 1.125.504 1.125 1.125m1.125 2.625h1.5m-1.5 0A1.125 1.125 0 0 1 18 7.125v-1.5m1.125 2.625c-.621 0-1.125.504-1.125 1.125v1.5m2.625-2.625c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125M18 5.625v5.25M7.125 12h9.75m-9.75 0A1.125 1.125 0 0 1 6 10.875M7.125 12C6.504 12 6 12.504 6 13.125m0-2.25C6 11.496 5.496 12 4.875 12M18 10.875c0 .621-.504 1.125-1.125 1.125M18 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m-12 5.25v-5.25m0 5.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125m-12 0v-1.5c0-.621-.504-1.125-1.125-1.125M18 18.375v-5.25m0 5.25v-1.5c0-.621.504-1.125 1.125-1.125M18 13.125v1.5c0 .621.504 1.125 1.125 1.125M18 13.125c0-.621.504-1.125 1.125-1.125M6 13.125v1.5c0 .621-.504 1.125-1.125 1.125M6 13.125C6 12.504 5.496 12 4.875 12m-1.5 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M19.125 12h1.5m0 0c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h1.5m14.25 0h1.5" />
</svg>`
      default:
        return '<svg class="navbar-svg-default mr-4 flex-shrink-0 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" /></svg>';

    }
  }
}




